import { Outlet, useLocation } from "react-router-dom";
import { TabBar } from "./TabBar";
import { Sidebar } from "./Sidebar";

function useActiveTab(): string {
  const location = useLocation();
  if (location.pathname.startsWith("/config")) return "config";
  if (location.pathname.startsWith("/calls")) return "calls";
  if (location.pathname.startsWith("/admin")) return "admin";
  return "config";
}

const sectionsWithSidebar = new Set(["config", "admin"]);

export function MainLayout() {
  const activeTab = useActiveTab();
  const showSidebar = sectionsWithSidebar.has(activeTab);

  return (
    <div className="flex flex-col h-screen overflow-hidden">
      <TabBar />
      <div className="flex flex-1 overflow-hidden">
        {showSidebar && <Sidebar section={activeTab} />}
        <main className="flex-1 overflow-y-auto p-6 scrollbar-thin">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
